import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Divider from "@mui/material/Divider";
import dayjs from "dayjs";
import axios from "../../../network/index";
import TextField from "@mui/material/TextField";
import ItemNotFound from "../../../utility/ItemNotFound";
import {
  ORDER_STATE_MAPPING,
  ORDER_STATE_ALL,
  DATE_FORMAT,
} from "../../../constants/string";
import FilterDropdown from "./FilterDropdown";
import OrderCard from "./OrderCard";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LottieError from "../../../components/LottieError";
import { useWarehouse } from "../../../contexts/WarehouseContext";
import { useDate } from "../../../contexts/DateContext";

const Orders = () => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { warehouseId } = useWarehouse();
  const { startDate, endDate, setStartDate, setEndDate, filter, setFilter } = useDate();

  const handleFilterSelect = (selectedItems) => {
    setFilter(selectedItems);
  };

  useEffect(() => {
    if (warehouseId) {
      const formData = new FormData();
      for (let i = 1; i <= 12; i++) {
        formData.append("orderState[]", i.toString());
      }
      formData.append("warehouseIds", warehouseId);
      formData.append("order[0][dir]", "desc");
      formData.append("ordertypefilter", "1");

      axios
        .post(
          "/orders/indexwithdate/" + startDate + "/" + endDate + "/" + "0?",
          formData
        )
        .then((data) => {
          setLoading(false);
          if (data.data.error) {
            setError(true);
          } else {
            setData(data.data.aaData);
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(true);
        });
    }
  }, [startDate, endDate, warehouseId]);

  const filterFreshOrders = (filter) => {
    const filteredOrders = data.filter(
      (order) =>
        filter.includes(ORDER_STATE_ALL) ||
        filter.includes(order.orderstate_nameAliase)
    );
    return filteredOrders;
  };

  const renderOrders = (filteredOrders) => {
    if (filteredOrders.length === 0 && !loading) {
      return <ItemNotFound />;
    }
    return filteredOrders.map((order) => (
      <OrderCard key={order.id} order={order} warehouseId={warehouseId} />
    ));
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "80% ",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <LottieError />;
  }

  return (
    <Box sx={{ background: theme.palette.background.main, height: "100%" }}>
      <Box
        justifyContent="center"
        sx={{ display: "flex", justifyContent: "center", flexDirection: "row" }}
      >
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs} >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                padding: "1vh",
                marginTop: 1,
              }}
            >
              <DatePicker
                disableFuture
                label="Start"
                defaultValue={dayjs(startDate)}
                maxDate={dayjs(endDate)}
                format="DD/MM/YYYY"
                onChange={(startDate) =>
                  setStartDate(dayjs(startDate).format(DATE_FORMAT))
                }
                renderInput={(props) => <TextField {...props} />}
                sx={{ background: "white" }}
              />
              <DatePicker
                disableFuture
                label="End"
                format="DD/MM/YYYY"
                defaultValue={dayjs(endDate)}
                minDate={dayjs(startDate)}
                onChange={(endDate) =>
                  setEndDate(dayjs(endDate).format(DATE_FORMAT))
                }
                renderInput={(props) => <TextField {...props} />}
                sx={{ marginLeft: "2vh", background: "white" }}
              />
            </Box>
          </LocalizationProvider>
        </Box>
        <Box
          sx={{
            flexDirection: "flex-end",
            marginTop: "1vh",
            marginRight: "1vh",
          }}
        >
          <FilterDropdown
            items={ORDER_STATE_MAPPING}
            onSelect={handleFilterSelect}
          />
        </Box>
      </Box>

      <Divider variant="middle" />
      <Box
        style={{
          overflow: "auto",
          paddingBottom: "70px",
        }}
      >
        <Grid container>{renderOrders(filterFreshOrders(filter))}</Grid>
      </Box>
    </Box>
  );
};

export default Orders;
